import { createGoogleUploadSources } from '@speles7172/file-console/google';

/**
 * Google Drive and Google Photos, offered in the file explorer's Upload menu.
 *
 * ⚠️ **The explorer this replaced had these, and losing them would be a
 * regression rather than a simplification.** The old
 * `components/files/FileExplorer.tsx` wired `useGoogleDrive` for both of its
 * modes — download a picked file into S3, or keep it as a Drive link — and a
 * planner who used them would open the new Files page to find the workflow
 * gone. The package generalised the same flow; this is where it is handed the
 * credentials.
 *
 * ⚠️ **The keys are build-time constants and are not secrets.** A browser API
 * key and an OAuth client id are public by construction; they are restricted by
 * HTTP referrer and origin in the Google console, which is where that
 * restriction belongs. Read the same way `useGoogleDrive` and
 * `useGooglePhotos` read them, so one project's configuration serves all three.
 *
 * ⚠️ **Returns an empty array when they are unset**, and the explorer then
 * renders a plain Upload button rather than a menu whose two entries cannot
 * open. Local development, where neither is usually set, is the common case for
 * that — and it is the package's behaviour, not a check repeated here.
 *
 * Computed once at module scope: `import.meta.env` is frozen at build time, so
 * there is nothing to react to and nothing for a `useMemo` to do.
 */
export const FILE_UPLOAD_SOURCES = createGoogleUploadSources({
  apiKey: import.meta.env.VITE_GOOGLE_API_KEY,
  clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID,
});
